import { postResource } from "services";

export function contactUs({ name, email, message }, onSuccess, onFail) {
  const path = "api/contactUs";
  const data = { name, email, message };
  postResource(path, data, onSuccess, onFail);
}
